export * from './CompanyOperationsCompactTableBody.types';
export { default as CompanyOperationsCompactTableBody } from './CompanyOperationsCompactTableBody';
